import { render, staticRenderFns } from "./sticky-screen.vue?vue&type=template&id=6540f10f&scoped=true&"
import script from "./sticky-screen.vue?vue&type=script&lang=js&"
export * from "./sticky-screen.vue?vue&type=script&lang=js&"
import style0 from "./sticky-screen.vue?vue&type=style&index=0&id=6540f10f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6540f10f",
  null
  
)

export default component.exports